import React from "react";
import { useHistory } from "react-router-dom";

import { BsArrowRight } from "react-icons/bs";

import { StyledGoBackButton } from "./styledGoBackButton";

export default function GoBackButtonComponent(props) {
  const history = useHistory();
  return (
    <StyledGoBackButton onClick={() => history.goBack()} className="go-back-link" {...props}>
      <BsArrowRight size={30} />
    </StyledGoBackButton>
  );
}
